import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { Clickable, ClickEventListener } from '@philips-emr/tws-core/lib/component/types';
import { AccessibilityService } from '@philips-emr/tws-core/lib/services';

const { scrollToTop, setFontSize, getFontSize, setContrastEnabled, isContrastEnabled, increaseFontSize, decreaseFontSize }  = AccessibilityService;

class AccessibilityAPI extends ComponentAPI implements Clickable {

  /** @event */
  @AwesomeEvent
  onClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onDoubleClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onContextMenuClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onScrollToMainMenu = new ClickEventListener();

  setFontSize(fontSize = 100): void {
    const { minFontSize, maxFontSize } = this.state;

    if (fontSize < minFontSize || fontSize > maxFontSize) {
      return;
    }

    setFontSize(fontSize);
  }

  getFontSize(): number {
    return getFontSize();
  }

  setContrastEnabled(contrastEnabled = false): void {
    setContrastEnabled(contrastEnabled);
  }

  isContrastEnabled(): boolean {
    return isContrastEnabled();
  }

  toggleContrast(): void {
    setContrastEnabled(!isContrastEnabled());
  }

  increaseFontSize(): void {
    const { fontSizeStep, maxFontSize } = this.state;
    increaseFontSize(fontSizeStep, maxFontSize);
  }

  decreaseFontSize(): void {
    const { fontSizeStep, minFontSize } = this.state;
    decreaseFontSize(fontSizeStep, minFontSize);
  }

  resetFontSize(): void {
    this.setFontSize();
  }

  setMinFontSize(minFontSize: number): void {
    this.setState({ minFontSize });
    this.setFontSize(Math.max(minFontSize, this.getFontSize()));
  }

  getMinFontSize(): number {
    return this.state.minFontSize;
  }

  setMaxFontSize(maxFontSize: number): void {
    this.setState({ maxFontSize });
    this.setFontSize(Math.min(maxFontSize, getFontSize()));
  }

  getMaxFontSize(): number {
    return this.state.maxFontSize;
  }

  setFontSizeStep(fontSizeStep: number): void {
    this.setState({ fontSizeStep });
  }

  getFontSizeStep(): number {
    return this.state.fontSizeStep;
  }

  scrollToTop(): void {
    scrollToTop();
  }

  clear(): void {
    this.resetFontSize();
    this.setContrastEnabled(false);
  }

}

export default AccessibilityAPI;
